import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentModulesModule } from './components/component-modules.module';
import { PopupPage } from './pages/popup/popup.page';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { TokenInterceptor } from './interceptor/interceptor';
import { MenuPage } from './pages/menu/menu.page';
import { SetPasswordPage } from './pages/set-password/set-password.page';
import { NgxPrintModule } from 'ngx-print';
import { FullInfoPage } from './pages/full-info/full-info.page';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from './helper/translateLoader';
import { ScrollbarThemeModule } from './directives/scrollbar-theme.directive';
import { UploadStatusPage } from './pages/upload-status/upload-status.page';
import { LottieAnimationViewModule } from 'ng-lottie';
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { WayyakTransactionPage } from './pages/wayyak-transaction/wayyak-transaction.page';
import { ViewAllPaymentLinkPage } from './pages/view-all-payment-link/view-all-payment-link.page';
import { ViewAllRedeemptionPage } from './pages/view-all-redeemption/view-all-redeemption.page';

@NgModule({
  declarations: [
    AppComponent,
    PopupPage,
    MenuPage,
    SetPasswordPage,
    FullInfoPage,
    UploadStatusPage,
    WayyakTransactionPage,
    ViewAllPaymentLinkPage,
    ViewAllRedeemptionPage
  ],
  entryComponents: [
    PopupPage,
    MenuPage,
    SetPasswordPage,
    FullInfoPage,
    UploadStatusPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ComponentModulesModule,
    HttpClientModule,
    NgxQRCodeModule,
    NgxPrintModule,
    ScrollbarThemeModule,
    LottieAnimationViewModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AngularFireModule.initializeApp(environment.FIREBASE_CONFIG),
    AngularFireMessagingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




